<template>
  <v-text-field outlined readonly v-model="computedValue" v-bind="$attrs">
    <layer-style-color-picker slot="append" v-model="computedValue" />
  </v-text-field>
</template>
<script>
export default {
  components: {
    LayerStyleColorPicker: () => import('@/components/settings/LayerStyleColorPicker')
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      }
    }
  }
};
</script>